import React from 'react';
import { StarIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { testimonials } from '../data/testimonials';
export function TestimonialsSection() {
  return <section className="bg-brand-alt px-4 py-20 md:py-24" data-id="element-151" data-mp="1n00ra3zw93vo">
      <Reveal className="mx-auto max-w-6xl" data-id="element-152" data-mp="1mzisp0predkl">
        <div className="mb-12 text-center" data-id="element-153" data-mp="1r1dvyar93110">
          <p className="text-[10px] font-extrabold uppercase tracking-[0.22em] text-brand-orange sm:text-xs" data-id="element-154" data-mp="1r02r07m2jn8b">
            Beliebt bei Lehrkräften
          </p>
          <h2 className="mt-4 text-3xl font-extrabold text-brand-navy md:text-4xl" data-id="element-155" data-mp="1i1h11re9p5xi">
            ★ Was Musiklehrkräfte sagen.
          </h2>
          <div className="mt-4 flex items-center justify-center gap-1" aria-label="Durchschnittliche Bewertung 5 von 5 Sternen" data-id="element-156" data-mp="142r54f36pcaq">
            {[1, 2, 3, 4, 5].map(star => <StarIcon key={star} className="h-5 w-5 fill-brand-orange text-brand-orange" aria-hidden="true" data-id="element-157" data-mp="2yfz0c7v2npww" />)}
          </div>
        </div>
        <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-158" data-mp="2uz81nnrgat7m">
          {testimonials.map(testimonial => <article key={testimonial.name} className="flex min-h-[210px] flex-col rounded-2xl border border-brand-line bg-brand-main p-7 shadow-sm" data-id="element-159" data-mp="34r4c7yaq4bsq">
              <div className="flex gap-1" aria-label="5 von 5 Sternen" data-id="element-160" data-mp="2c2qdfgbt9bg4">
                {[1, 2, 3, 4, 5].map(star => <StarIcon key={star} className="h-4 w-4 fill-brand-orange text-brand-orange" aria-hidden="true" data-id="element-161" data-mp="274f2f29s4uwb" />)}
              </div>
              <p className="mt-5 flex-1 text-base font-semibold leading-relaxed text-brand-text" data-id="element-162" data-mp="2h08c8dw46aae">
                {testimonial.quote}
              </p>
              <div className="mt-6" data-id="element-163" data-mp="3sh8cpwsm7vfi">
                <p className="text-sm font-bold text-brand-navy" data-id="element-164" data-mp="3sg6rx0lsrukl">
                  {testimonial.name}
                </p>
                <p className="text-xs text-brand-gray" data-id="element-165" data-mp="3eio3v16g2ab">{testimonial.role}</p>
              </div>
            </article>)}
        </div>
      </Reveal>
    </section>;
}